<template>
    <div>
        <div class="variable-content">
            <div class="d-flex flex-column justify-content-start align-items-stretch">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="text-primary font-weight-bold mb-0 mx-2 text-uppercase">
                        {{ goal ? `${step}/${goal.parameters.mand_opportunities}` : "" }}&nbsp;Enter
                        reinforcer
                    </p>
                </div>
                <input
                    type="text"
                    v-model="attempt.reinforcer"
                    name="target"
                    class="form-control form-control-sm"
                />
            </div>

            <prompt
                :iconset="iconset"
                :session="true"
                :slash="attempt.modifier === 'Item present'"
                :selected-prompt="selectedButton ? selectedButton[1] : null"
                @select-prompt="selectedButton = $event"
            ></prompt>

            <div v-if="goal" class="d-flex justify-content-start align-items-center mt-2">
                <span
                    v-for="(t, i) in goal.parameters.parameters"
                    class="form-check form-check-inline w-100"
                >
                    <input
                        class="form-control form-control-sm mr-2"
                        style="max-width:2rem;"
                        type="checkbox"
                        :id="`target-${i}`"
                        :value="t"
                        v-model="parameters"
                    />
                    <label class="mb-0" :for="`target-${i}`" style="line-height: 0.8;"
                        ><small class="text-muted font-italic">{{ t }}</small></label
                    >
                </span>
            </div>

            <div class="my-2 w-100 d-flex justify-content-center">
                <a
                    class="btn btn-sm text-white text-uppercase font-weight-bold"
                    :class="selectedButton && attempt.reinforcer ? 'btn-primary' : 'btn-light'"
                    @click="selectedButton && attempt.reinforcer ? addAttempt() : null"
                    >Save Reinforcer</a
                >
            </div>

            <hr
                style="width:100%;margin: 0.5rem auto;color:#c3c3c3;background: #c3c3c3; height: 1px;"
            />

            <div class="row p-2">
                <div class="col-9 pl-1" v-if="goal">
                    <div
                        class="d-flex flex-column justify-content-start align-items-start mx-1 position-relative flex-wrap"
                        :style="{
                            maxHeight:
                                goal.parameters && goal.parameters.mand_opportunities
                                    ? Math.ceil(goal.parameters.mand_opportunities / 3) * 2 + 'rem'
                                    : '6rem',
                        }"
                    >
                        <div class="d-flex mb-1 attempt" v-for="(result, i) in results">
                            <span class="pl-1 font-mono"
                                >{{
                                    goal.parameters && goal.parameters.mand_opportunities > 9
                                        ? helpers.zeroPad(i + 1)
                                        : i + 1
                                }}.</span
                            >
                            <span
                                class="ml-2"
                                v-if="result && result.hasOwnProperty('detailed_result')"
                            >
                                <prompt
                                    :mini="true"
                                    :prompt="[null, iconset, result.detailed_result]"
                                ></prompt>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-3">
                    <h4 class="pl-1">{{ successRate }}%</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prompt from "../../ui/PromptIcon";
import { helpers } from "../../../plugins/helpers";

export default {
    name: "Mand",
    props: ["goal", "date", "customization", "flagData", "notesData"],
    components: { Prompt },
    data() {
        return {
            helpers,
            step: 1,
            results: [],
            parameters: [],
            attempt: {
                //    modifier: null,
            },
            selectedButton: null,
        };
    },

    computed: {
        iconset() {
            //return this.customization && this.customization.hasOwnProperty('default_options') && this.customization.default_options  && !isNaN(this.customization.default_options.iconset) ? this.customization.default_options.iconset : 0;
            return 8; //Index of Mand-specific iconset with "Item present" and "MO" on PromptIcon.vue
        },

        successRate() {
            if (this.results.length) {
                return parseInt(
                    (100 * this.results.filter(r => r.result).length) / this.results.length
                );
            }
        },
    },

    methods: {
        addAttempt() {
            //this.attempt.result = this.attempt.modifier === 'Item present' ? 0 : this.selectedButton[0];
            this.attempt.result = this.selectedButton[0];
            this.attempt.detailed_result = this.selectedButton[1];
            this.attempt.parameters = this.parameters;
            if (this.step <= this.goal.parameters.mand_opportunities) {
                this.$set(this.results, this.step - 1, this.attempt);
                this.parameters = [];
                this.attempt = {
                    //    modifier: null,
                };
            }
            if (this.step < this.goal.parameters.mand_opportunities) {
                this.step++;
            }
            this.selectedButton = null;
        },

        saveTrackerData() {
            let data = {
                session_at: this.date
                    ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                    : this.moment().format("YYYY-MM-DD HH:mm:ss"),
                notes: this.notesData,
                data: {
                    results: this.results,
                    iconset: this.iconset,
                    type: "mand",
                    success_rate: this.successRate,
                    success: this.results.filter(r => r.result).length,
                },
                is_flagged: this.flagData,
            };
            axios
                .post(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, data)
                .then(r => {
                    this.reportResult(true);
                })
                .catch(error => {
                    this.$emit("save-draft", { error, data });
                    this.reportResult(false);
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(error);
                });
        },

        reportResult(success) {
            this.$emit("saved", success);
            if (success) {
                this.$emit(
                    "close-tracker",
                    this.goal.title + ": " + `Scored ${this.successRate}%` + " - " + this.notesData
                );
            }
        },

        undoAttempt() {
            this.results.pop();
            if (this.step > 1) {
                this.step--;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.attempt {
    border-left: solid 1px #8f8f8f;
    width: 60px;
    height: 1.67rem;
    display: flex;
    align-items: center;
}
h4 {
    border-left: solid 1px #8f8f8f;
}
</style>
